import { render, staticRenderFns } from "./AddTable.vue?vue&type=template&id=5ab66408&scoped=true"
import script from "./AddTable.vue?vue&type=script&lang=js"
export * from "./AddTable.vue?vue&type=script&lang=js"
import style0 from "./AddTable.vue?vue&type=style&index=0&id=5ab66408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab66408",
  null
  
)

export default component.exports